import React from 'react';

import { compose, withProps } from 'recompose';
import {
  withScriptjs,
  withGoogleMap,
  GoogleMap,
  Polyline,
  Marker
} from 'react-google-maps';

const routeColours = [
  '#E91E63',
  '#2196F3',
  '#00BCD4',
  '#4CAF50',
  '#FF5722',
  '#607D8B'
];

const Map = compose(
  withProps({
    googleMapURL:
      'https://maps.googleapis.com/maps/api/js?v=3.exp&key=AIzaSyBnTijcj2_pmgAJI_Oq-4wdTg3_rMa8ORU&libraries=geometry,drawing,places',
    loadingElement: <div style={{ height: `100%` }} />,
    containerElement: <div className="map-container" style={{ position: 'absolute', top: 0, left: 0, right: 0, bottom: 0,  }} />,
    mapElement: <div style={{ height: `100%` }} />
  }),
  withScriptjs,
  withGoogleMap
)(props => {
  // Bounds
  const bounds = new window.google.maps.LatLngBounds();
  bounds.extend({
    lat: props.data.bounds.minlat,
    lng: props.data.bounds.minlon
  });
  bounds.extend({
    lat: props.data.bounds.maxlat,
    lng: props.data.bounds.maxlon
  });

  return (
    <GoogleMap
      ref={map => {
        map && map.fitBounds(bounds);
      }}
      defaultZoom={8}
      {...props}
    >
      {
        props.data.routes.map((route, index) => {

          return (
            <React.Fragment key={index}>
              {
                props.showWaypoints && route.points.map((point, index) => (
                  <Marker key={`marker_${index}`} position={{ lat: point.lat, lng: point.lng }} />
                ))
              }
              <Polyline key={index} path={route.points} options={{ strokeColor: routeColours[index]}} />
            </React.Fragment>
          )
        })
      }
    </GoogleMap>
  );
});

export default class PointMapComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return <Map {...this.props} />;
  }
}
